export default [
  {
    path: "/intoFj", //走进福建
    name: "intoFj",
    component: () =>
      import("@/view/CloudFair/Government/secondPage/fj/intoFj.vue")
  },
  {
    path: "/platformCarrierFj", //平台载体
    name: "platformCarrierFj",
    component: () =>
      import("@/view/CloudFair/Government/secondPage/fj/platformCarrierFj.vue"),
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/industrialClusters", //产业集群
    name: "industrialClusters",
    component: () =>
      import("@/view/CloudFair/Government/secondPage/fj/industrialClusters.vue"),
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/investmentOpportunitiesFj", //项目清单
    name: "investmentOpportunitiesFj",
    component: () =>
      import("@/view/CloudFair/Government/secondPage/fj/investmentOpportunitiesFj.vue"),
    meta: {
      keepAlive: true
    }
  },

  {
    path: "/investmentPolicyFj", //投资政策
    name: "investmentPolicyFj",
    component: () =>
      import("@/view/CloudFair/Government/secondPage/fj/investmentPolicyFj.vue"),
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/investmentServicesFj", //投资服务
    name: "investmentServicesFj",
    component: () =>
      import("@/view/CloudFair/Government/secondPage/fj/investmentServicesFj.vue")
  },
  {
    path: "/contactUsFj", //联系我们
    name: "contactUsFj",
    component: () =>
      import("@/view/CloudFair/Government/secondPage/fj/contactUsFj.vue")
  },
  {
    path: "/platformInfoFj", //平台详情
    name: "platformInfoFj",
    component: () =>
      import("@/view/CloudFair/Government/secondPage/fj/info/platformInfoFj.vue")
  },
  {
    path: "/industrialClustersInfoFj", //产业集群详情
    name: "industrialClustersInfoFj",
    component: () =>
      import("@/view/CloudFair/Government/secondPage/fj/info/industrialClustersInfoFj.vue")
  },
  {
    path: "/investmentServiceInfoFj", //产业集群详情
    name: "investmentServiceInfoFj",
    component: () =>
      import("@/view/CloudFair/Government/secondPage/fj/info/investmentServiceInfoFj.vue")
  },
  {
    path: "/charmFj", //魅力福建
    name: "charmFj",
    component: () =>
      import("@/view/CloudFair/Government/secondPage/fj/charmFj.vue")
  }
];



// WEBPACK FOOTER //
// ./src/router/cloudFair/fj.js